__webpack_require__.p = "/wealthguard-tool/";